module.exports = __webpack_public_path__ + "static/media/ZeitungMonoPro-Bold.fda6de64.woff2";